import { render } from "./Tem001.vue?vue&type=template&id=473e9028&scoped=true"
import script from "./Tem001.vue?vue&type=script&lang=js"
export * from "./Tem001.vue?vue&type=script&lang=js"

import "./Tem001.vue?vue&type=style&index=0&id=473e9028&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-473e9028"]])

export default __exports__